import styled from '@emotion/styled';

export default styled.div`
	width: 100%;
	max-height: 100%;

	.layout-forms-input-wrapper {
		margin-bottom: 0;
	}

	.style-outline {
		.layout-forms-input-wrapper {
			.label-wrapper {
				.label-body {
					.layout-forms-input-label {
						opacity: 1;
					}
				}
			}
		}
	}
`;
